module.exports = __webpack_public_path__ + "img/vip2.2c8af092.png";